import { useLang } from "@/i18n";

const Diamond = () => <span className="inline-block h-2 w-2 rotate-45 bg-[#C87D55]" />;

export const Marquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee, ...t.marquee];

  return (
    <div
      data-testid="marquee-strip"
      className="overflow-hidden border-y border-[#E4DDD0] bg-[#F3EFE6] py-5"
    >
      <div className="animate-kall-marquee flex w-max items-center gap-10 pr-10">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {items.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10 whitespace-nowrap">
                <span className="font-serif text-lg italic text-[#0A1F18]">
                  {item}
                </span>
                <Diamond />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
